import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, OnInit, ElementRef, forwardRef, Renderer, Input } from '@angular/core';
import { config } from '../../../../environments/config';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateComponent),
      multi: true
    }
  ]
})
export class InputDateComponent implements ControlValueAccessor, OnInit {
  @Input() format = 'MM/DD/YYYY';
  
  public _date;

  set date(val) {
    this._date = val;
    this.propagateChange(this._date);
  }

  get date() {
    return this._date;
  }

  public propagateChange = (val: any) => {};

  constructor(private el: ElementRef, private renderer: Renderer) {}

  writeValue(value: any): void {
    if (value !== undefined) {
      this.date = value;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  ngOnInit() {
    $(this.el.nativeElement.parentNode).datetimepicker({
      sideBySide: true,
      format: this.format,
      allowInputToggle: true
    });
    const _this = this;
    $(this.el.nativeElement.parentNode).on('dp.change', function(e) {
      _this.propagateChange(e.date);
    });
  }
}
